<template>
  <div>
    <img v-if="isImage" :src="file.url" style="display: block; max-width: 100%;">
    <video v-else-if="isVideo" :src="file.url" controls width="100%" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { RemoteFile } from '../type';
import { isImage, isVideo } from '.';

export default defineComponent({
  props: {
    file: {
      type: Object as () => RemoteFile,
      required: true,
    },
  },
  computed: {
    isImage(): boolean {
      return isImage(this.file.url);
    },
    isVideo(): boolean {
      return isVideo(this.file.url);
    },
  },
});
</script>
